<template>
    <div v-loading="loading">
        <apply-header :flag="'1'"></apply-header>
        <div class="main" :style="{'min-height':(getHeight-80)+'px'}">
            <Side :step="'2'"></Side>
            <section>
                <div class="info-form" v-if="!showResult&&hasFinished">
                    <div class="box">
                        <h1 class="serviceTestTitle">eAssist Medical Billing/Coding Assessment Test</h1>
                        <div class="mt10 fs14 lh25">This vetting quiz is used to assess eligibility for placement in the eAssist DMB Department. Combined with
                           a one-on-one interview with the department lead this tool will determine which position will best utilize your
                           experience and knowledge.
                        </div>
                        <div class="mt20 lh25 fs14">Please review the below cases (taken from actual submissions to our medical billing service) and explain
                            which CPT codes you would crosscode to as well as which ICD-10 codes you would assign for diagnosis.
                            The top portion of each question is a listing of procedures while the bottom portion is the clinical notes
                            submitted with the request. All of our submissions come to us in CDT code format with no assigned
                            diagnosis codes so you must be diligent in reviewing the information provided to make sure the most
                            comprehensive claim possible is sent to the carrier.
                        </div>
                        <p class="required" style="margin: 10px 0">* Required</p>
                    </div>

                    <el-form :model="form" :inline="false" :rules="rules" ref="form">
                        <div class="box">
                            <div>1) What is CPT an abbreviation for?<span class="required">*</span></div>
                            <el-form-item ref="sub0" prop="sub0" class="mt20">
                                <el-input type="textarea" v-model="form.sub0" :disabled="isAdmin" placeholder="Your answer"></el-input>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub1!=4" :src="wrong"></el-image>
                                2) Which ICD-10 code section is used to describe injuries?<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub1">
                                <el-radio-group ref="sub1" v-model="form.sub1" :disabled="isAdmin">
                                    <el-radio :label="0">V</el-radio><br>
                                    <el-radio :label="1">W</el-radio><br>
                                    <el-radio :label="2">X</el-radio><br>
                                    <el-radio :label="3">Y</el-radio><br>
                                    <el-radio :label="4">All of the above</el-radio>
                                    <el-image v-if="isAdmin&&form.sub1!=4" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub2!=0" :src="wrong"></el-image>
                                3) If you were sending a claim for an oral surgeon who removed impacted wisdom
                                teeth in his office under IV sedation, what place of service would you list on the claim?<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub2">
                                <el-radio-group ref="sub2" style="width: 100%" v-model="form.sub2" :disabled="isAdmin">
                                    <el-radio :label="0">11</el-radio>
                                    <el-image v-if="isAdmin&&form.sub2!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">21</el-radio><br>
                                    <el-radio :label="2">23</el-radio><br>
                                    <el-radio :label="3">50</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&!correctSoap" :src="wrong"></el-image>
                                4) What does SOAP stand for?<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub3" class="mt20">
                                <el-input type="textarea" ref="sub3" v-model="form.sub3" placeholder="Your answer" :disabled="isAdmin" :style="{width:(isAdmin&&!correctSoap?'45%':'100%')}"></el-input>
                                <el-input type="textarea" ref="sub3" v-model="rightAnswerSOAP" placeholder="Your answer" :disabled="true"
                                          :style="{width:(isAdmin&&!correctSoap?'45%':'0%'),display:(isAdmin&&!correctSoap?'inline-block':'none'),'margin-left':'10px'}"></el-input>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub4!=1" :src="wrong"></el-image>
                                5) At what point should you followup on a submitted claim? <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub4">
                                <el-radio-group ref="sub4" v-model="form.sub4" :disabled="isAdmin">
                                    <el-radio :label="0">5 business days</el-radio><br>
                                    <el-radio :label="1">14 business days</el-radio>
                                    <el-image v-if="isAdmin&&form.sub4!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">30 business days</el-radio><br>
                                    <el-radio :label="3">45 days</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub5!=3" :src="wrong"></el-image>
                                6) In what scenario would you use modifier 25?<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub5">
                                <el-radio-group ref="sub5" v-model="form.sub5" :disabled="isAdmin">
                                    <el-radio :label="0">Unrelated E&M Service, Same Physician, During Postoperative Period</el-radio><br>
                                    <el-radio :label="1">Unusual Anesthesia </el-radio><br>
                                    <el-radio :label="2">Unusual Procedural Services</el-radio><br>
                                    <el-radio :label="3"><div class="radioText">Separately Identifiable E&M Svc by the Same Physician on the Same Day of<br v-if="smallScreen"> Procedure or Other Svc</div></el-radio>
                                    <el-image v-if="isAdmin&&form.sub5!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub6!=2" :src="wrong"></el-image>
                                7) When would it be appropriate to use Modifier 47?<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub6">
                                <el-radio-group ref="sub6" v-model="form.sub6" :disabled="isAdmin">
                                    <el-radio :label="0">Bilateral Procedure</el-radio><br>
                                    <el-radio :label="1">Multiple Procedures</el-radio><br>
                                    <el-radio :label="2">Anesthesia by Surgeon</el-radio>
                                    <el-image v-if="isAdmin&&form.sub6!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">None of the above</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub7!=2" :src="wrong"></el-image>
                                8) Which modifier signifies multiple procedures?<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub7">
                                <el-radio-group ref="sub7" v-model="form.sub7" :disabled="isAdmin">
                                    <el-radio :label="0">26</el-radio><br>
                                    <el-radio :label="1">50</el-radio><br>
                                    <el-radio :label="2">51</el-radio><el-image v-if="isAdmin&&form.sub7!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">59</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub8!=1" :src="wrong"></el-image>
                                9) In what scenario would use you use modifier KX?<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub8">
                                <el-radio-group ref="sub8" v-model="form.sub8" :disabled="isAdmin">
                                    <el-radio :label="0">When a DME appliance is supplied by a Medicare provider.</el-radio><br>
                                    <el-radio :label="1"><div class="radioText">To indicate that coverage criteria is met and that documentation exists to support<br v-if="smallScreen"> the medical
                                        necessity DME appliance.</div></el-radio><el-image v-if="isAdmin&&form.sub8!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :class="[smallScreen?'mt10':'']" :label="2">To indicate that a DME appliance was purchased.</el-radio><br>
                                    <el-radio :label="3">None of the above.</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&(!form.sub9.a||!form.sub9.b||!form.sub9.c||!form.sub9.d)" :src="wrong"></el-image>
                                10) A claim for extraction and implants was denied for lack of medical necessity. The
                                patient had oral cancer and teeth were extracted at the request of the
                                oncology/primary care team before chemo/radiation treatments were started. What
                                types of information could you use to try to appeal this for the patient to obtain
                                coverage? (check all that apply)<span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub9" ref="sub9">
                                <div>
                                    <el-checkbox v-model="form.sub9.a" :disabled="isAdmin">Referral from the oncologist</el-checkbox>
                                    <el-image v-if="isAdmin&&(!form.sub9.a||!form.sub9.b||!form.sub9.c||!form.sub9.d)" class="rightPic" :src="right"></el-image><br>
                                    <el-checkbox v-model="form.sub9.b" :disabled="isAdmin">Intraoral photos</el-checkbox>
                                    <el-image v-if="isAdmin&&(!form.sub9.a||!form.sub9.b||!form.sub9.c||!form.sub9.d)" class="rightPic" :src="right"></el-image><br>
                                    <el-checkbox v-model="form.sub9.c" :disabled="isAdmin">Xrays</el-checkbox>
                                    <el-image v-if="isAdmin&&(!form.sub9.a||!form.sub9.b||!form.sub9.c||!form.sub9.d)" class="rightPic" :src="right"></el-image><br>
                                    <el-checkbox v-model="form.sub9.d" :disabled="isAdmin">Treatment notes from oncology</el-checkbox>
                                    <el-image v-if="isAdmin&&(!form.sub9.a||!form.sub9.b||!form.sub9.c||!form.sub9.d)" class="rightPic" :src="right"></el-image>
                                </div>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub10!=3" :src="wrong"></el-image>
                                11) Assign the appropriate CPT code(s) to this visit: Patient of Dr Smith's presents to
                                office with broken tooth on #5, patient states that she has always had weak enamel
                                and has complete upper arch crowned to keep teeth from breaking. Patient said she
                                was eating a sandwich and tooth broke in half. Upon xray, tooth is not able to be
                                restored. Implant placement and bone grafting done today. CBCT scan was taken to
                                determine sinus and TM J positioning. Due to unique root angle and what looks to be
                                abscess around root, significant Grafting will need to be placed in the future to allow
                                for correct occlusion. Patient has history of ADHD and anxiety this could all be a
                                reasoning of broken teeth. Next visit: TMD, TMJ evaluation.<span class="required">*</span></div>
                            <div class="score" >5 points</div>
                            <el-form-item prop="sub10">
                                <el-radio-group ref="sub10" v-model="form.sub10" :disabled="isAdmin">
                                    <el-radio :label="0">99201,21248,70310</el-radio><br>
                                    <el-radio :label="1">99241,21210,70486</el-radio><br>
                                    <el-radio :label="2">21210,70310,D6010,99213 </el-radio><br>
                                    <el-radio :label="3">21248,21210,70486,99241</el-radio>
                                    <el-image v-if="isAdmin&&form.sub10!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub11!=1" :src="wrong"></el-image>
                                12) Assign the appropriate ICD-10 code(s) to this visit: CANCER SURVIVOR, HAD
                                RADIATION TREATMENT, PT MISSING TEETH #14/15; PLACING IMPLANT ON TEETH
                                #14/15 AND BONE GRAFT ON TEETH #14/15; PT'S DENTAL HISTORY IS AS FOLLOWS:
                                PT COMPLETED INVISALIGN IN 2015, PT HAD SCALING AND ROOT PLANING IN 2013
                                AND HAS BEEN COMING IN FOR REGULAR ROUTINE CLEANINGS.<span class="required">*</span></div>
                            <div class="score" >5 points</div>
                            <el-form-item prop="sub11">
                                <el-radio-group ref="sub11" v-model="form.sub11" :disabled="isAdmin">
                                    <el-radio :label="0">K05.6,K08.429,Z86.03,Z92.3</el-radio><br>
                                    <el-radio :label="1">K08.499,K05.6,Z85.9,Z92.3</el-radio>
                                    <el-image v-if="isAdmin&&form.sub11!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Z92.3,K08.499</el-radio><br>
                                    <el-radio :label="3"> K03.6,K08.429,Z92.3</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub12!=0" :src="wrong"></el-image>
                                13) Assign the appropriate CPT code(s) to this visit: OMS: This is a 70 yo woman
                                referred for ext of #20 after pain in the area. There is no referral note on record. Pt
                                has been troubled by pain inn the area for several years and has had 18 and 19 ext'd in
                                the past. Pt has had three implant placed and excision of a lingual carcinoma (-2008)
                                bot no RT，chemo or neck dissection. She has a 20 pack-year hx of smoking and
                                drinks ETOH on a daily basis. She would like implant in the LLQ. PMH: left ventral
                                carcinoma of the tongue, Lyme disease, s/p TAH, s/p wrist surgery, s/p bilateral ACL
                                repairs, anemai，arthritis，glaucoma, (+) bruxism Meds: amlodipine，lrbesartant
                                atorvastatin, spironolactone, Ziaptan (ophthalmologic) All: NKDA SH: d/c'd smoking
                                year ago, daily ETOH PE: 132/59, 61, 98% healed scar of left ventral tongue linear flat
                                hyperkeratotic appearing area w/ poorly defined surrounding region of erythema of
                                the right ventral tongue (〜16mm x 3 mm) no cervical adenopathy crowned #20 s/p
                                RCT Assess: 1. hyperkeratotic region of right tongue 2. failing #20 Plan: 1. Incisional bx
                                2. Extract 20 and place xenograft Proc: 4 % Septo/epi x 5.1 mL 1. Surg ext of 20 by
                                MPF, elevation, forceps. Debrided. Placed Bio-Oss and Bio-Gide membrane closed w/
                                3-0 GS 2. Incisional tongue bx by use of tenting BSS. Ellipitical incision. Undermined
                                ST and delivered for histopath to ECHN. Closed w/ 4-0 CGS. POIG. F/U in 7-10 d. Rxs
                                on file. Counseled re. use of opioids and advised pt to d/c T-3. ADA CODE(S) BILLED
                                BY THE OFFICE: D7286 - LR<span class="required">*</span></div>
                            <div class="score" >5 points</div>
                            <el-form-item prop="sub12">
                                <el-radio-group ref="sub12" v-model="form.sub12" :disabled="isAdmin">
                                    <el-radio :label="0">41899,21215,41870,41100</el-radio>
                                    <el-image v-if="isAdmin&&form.sub12!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">41899,21210 </el-radio><br>
                                    <el-radio :label="2">41899,41870</el-radio><br>
                                    <el-radio :label="3">21215,41100</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub13!=1" :src="wrong"></el-image>
                                14) Assign the appropriate ICD-10 code(s) to this visit: Patient has severe
                                claustrophobia and is not a candidate for Cpap treatment. She needs a custom fit
                                appliance for her sleep apnea. Patient's sleep study indicates an RDI of 20 with an 02
                                saturation below 90% for at least 70 minutes of the study. Pt has history of neck
                                trauma, high blood pressure, diabetes and high cholesterol. CODE(S) BILLED BY THE
                                OFFICE: E0486<span class="required">*</span></div>
                            <div class="score" >5 points</div>
                            <el-form-item prop="sub13">
                                <el-radio-group ref="sub13" v-model="form.sub13" :disabled="isAdmin">
                                    <el-radio :label="0">G47.33,F40.240,I10,E11.9</el-radio><br>
                                    <el-radio :label="1">G47.33,F40.240,I10,E11.9,E78.49</el-radio>
                                    <el-image v-if="isAdmin&&form.sub13!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">G47.33,F40.240,E11.9,E78.49 </el-radio><br>
                                    <el-radio :label="3">G47.33.I10.E11.9</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub14!=3" :src="wrong"></el-image>
                                15) Assign the appropriate CPT and ICD-10 code(s) to this visit: Patient was diagnosed
                                with periodontal disease in 2007 was under the care of Dr. X Periodontist. Patient was
                                seen by Dr. Y where he was seen under general care，where they diagnosed him with
                                severe periodontal disease. On 8/10/2017 Patient was diagnosed from Dr. X's office
                                with extreme periodontal disease with class two mobility extracted 18 and 19. On
                                8/14/2017 We extracted 5,6,7,9,10,11,13, 20, 21, 22, and 27. Patient was referred by Dr. X
                                for sinus augmentation, implant placement f
                                bone grafting and complete hybrid
                                zirconium restorations DOs 9-20-2017 CBCT taken to measure bone density, with of
                                ridge and length of bone from sinus to maxillary palate. Patient presents with an
                                upper right and left sinus lift with bone grafting due to loss of ridge and unstable
                                bone due to missing teeth. Sinus was lifted and grafted from 3mm to > 8MM of bone.
                                implants were placed in sites Tooth #:6,8,9,11 24,25,19,30 Bone grafted into sites
                                6,8,9,11,24,25,19,30. Additional bone was placed in site 26 and 23 due to missing bone
                                ridge. ADA C〇DE(S) BILLED BY THE OFFICE: D0367, D7953 x 10 units, D6010 x 8 units，
                                D9241 x 2 units, D7952<span class="required">*</span></div>
                            <div class="score" >8 points</div>
                            <el-form-item prop="sub14">
                                <el-radio-group ref="sub14" v-model="form.sub14" :disabled="isAdmin">
                                    <el-radio :label="0">CPT: 21210, 21248, 70486, 99152, 99153 ICD: K05.323, K08.429 </el-radio><br>
                                    <el-radio :label="1">CPT: 21210, 21215, 70486, 99152, 99153 ICD: K05.322, K08.429</el-radio><br>
                                    <el-radio :label="2">CPT: 21210, 21215, 21248, 70486, 99152,99153 ICD: K05.323, K08.424 </el-radio><br>
                                    <el-radio :label="3">CPT: 21210, 21215, 21248, 70486, 99152,99153 ICD: K05.323, K08.429</el-radio>
                                    <el-image v-if="isAdmin&&form.sub14!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub15!=2" :src="wrong"></el-image>
                                16) Assign the appropriate CPT and ICD-10 code(s) to this visit: Patient came in today
                                as a new patient He said he thinks he is having TMJ issues. Pt said it has not always
                                happened it has started about a month ago. He said there is clicking and popping on
                                both sides. He said there is pain associated with it as well. The pain is more on the
                                right side than the let side. I took a CBCT scan of pt. Dr. X came in and spoke with pt
                                she informed him that on the right side that the click is going forward and popping
                                back in place. It looks also causing arthritic changes on pts left side. Dr. X suggested
                                to pt that he go to an ENT Dr for his sinuses. There is nasal blockage on the left side
                                and has mucus building up on the right side. She also let pt know that he has a
                                deviated septum he said he is aware that his nose was broken back in high school. Dr.
                                X went over the de flame diet with pt he got a copy of that as well as tmj information.
                                We gave pt referral forms for the ent as well as a sleep study. Splint is for upper and
                                lower arch. ADA CODE(S) BILLED BY THE OFFICE: D7880
                                <span class="required">*</span></div>
                            <div class="score" >5 points</div>
                            <el-form-item prop="sub15">
                                <el-radio-group ref="sub15" v-model="form.sub15" :disabled="isAdmin">
                                    <el-radio :label="0">CPT: 21085 ICD: M26.603, M26.623, R68.84, J34.2  </el-radio><br>
                                    <el-radio :label="1">CPT: S8262 ICD: M26.603, M26.623, R68.84</el-radio><br>
                                    <el-radio :label="2">CPT: 21089 ICD: M26.603, M26.623, R68.84, J34.2 </el-radio>
                                    <el-image v-if="isAdmin&&form.sub15!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">CPT: 21085 ICD: M26.603, M26.623, R68.84</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub16!=1" :src="wrong"></el-image>
                                17) Assign the appropriate CPT code(s) to this visit: PT. REPORTS FOR 6 MTH RECARE/
                                EXAM APPT. PT CONSENTS TO TREATMENT TODAY CC TODAY: Pt states she catches
                                food between #18 and #19 (fillings done 5/2015) MED HX UPDATED: No changes per
                                pt. TMJ; Deviates to left upon opening ROM: WNL MEDIAL PTERYGOIDS: Tender all
                                muscles bilat. MASSETER: Tender masseters, insert，temporalis. E〇E: WNUOE: MP 1.
                                Class I bilat. Bilat mand tori. A: PERIO DX Type I stable DIAGNOSIS: Myalgia and
                                arthralgia，tender all muscles. #9- ML chip. #10- MF chip. #19- Fx off DB cusp，open
                                contact, defective restoration. ADA CODE(S) BILLED BY THE OFFICE: D7880r
                                D0120,D0470, D0367.
                                <span class="required">*</span></div>
                            <div class="score" >5 points</div>
                            <el-form-item prop="sub16">
                                <el-radio-group ref="sub16" v-model="form.sub16" :disabled="isAdmin">
                                    <el-radio :label="0">CPT: 21089, 99213, 70486 ICD: M26.623, R68.84, M26.53, M26.603</el-radio><br>
                                    <el-radio :label="1">CPT: 21089, 99213, A4580, 70486 ICD: M26.623, R68.84, M26.53, M26.603</el-radio>
                                    <el-image v-if="isAdmin&&form.sub16!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">CPT: 21085, 99213, A4580, 70486 ICD: M26.623, R68.84, M26.53, M26.603</el-radio><br>
                                    <el-radio :label="3">CPT: 21085, 99212, A4580, 70486 ICD: M26.623, R68.84, M26.53, M26.603</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub17!=1" :src="wrong"></el-image>
                                18) Assign the appropriate procedure code(s) to this visit: Patient has a long history of
                                has been given multiple medications for migraines with no relief. Patient has used
                                Botox in the past to help with symptoms of migraines and they have reported they
                                experienced significant improvement. Administered 100 units of Botox (20 R
                                temporalis, 20 L temporalis, 30 R masseter, 30 L masseter).
                                <span class="required">*</span></div>
                            <div class="score" >5 points</div>
                            <el-form-item prop="sub17">
                                <el-radio-group ref="sub17" v-model="form.sub17" :disabled="isAdmin">
                                    <el-radio :label="0">J0585</el-radio><br>
                                    <el-radio :label="1">64615, J0585</el-radio>
                                    <el-image v-if="isAdmin&&form.sub17!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">J0586</el-radio><br>
                                    <el-radio :label="3">Q2040</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub18!=1" :src="wrong"></el-image>
                                19) ICD-9 and ICD-10 codes can appear together on the same claim
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub18">
                                <el-radio-group ref="sub18" v-model="form.sub18" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio><br>
                                    <el-radio :label="1">False</el-radio>
                                    <el-image v-if="isAdmin&&form.sub18!=1" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub19!=0" :src="wrong"></el-image>
                                20) ICD-9 and ICD-10 codes can appear together on the same claim
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub19">
                                <el-radio-group ref="sub19" v-model="form.sub19" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio>
                                    <el-image v-if="isAdmin&&form.sub19!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">False</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub20!=3" :src="wrong"></el-image>
                                21) What is the medical crosscode for D7240?
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub20">
                                <el-radio-group ref="sub20" v-model="form.sub20" :disabled="isAdmin">
                                    <el-radio :label="0">41899</el-radio><br>
                                    <el-radio :label="1">D7240</el-radio><br>
                                    <el-radio :label="2">21210</el-radio><br>
                                    <el-radio :label="3">Either D7240 or 41899 can be appropriate, depending on the payer.</el-radio>
                                    <el-image v-if="isAdmin&&form.sub20!=3" class="rightPic" :src="right"></el-image>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub21!=1" :src="wrong"></el-image>
                                22) When can a consultation be charged?
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub21">
                                <el-radio-group ref="sub21" v-model="form.sub21" :disabled="isAdmin">
                                    <el-radio :label="0">If the Dr spends more than 10 minutes with the patient</el-radio><br>
                                    <el-radio :label="1">If there is a referring Dr</el-radio>
                                    <el-image v-if="isAdmin&&form.sub21!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Anytime the Dr sees a patient</el-radio><br>
                                    <el-radio :label="3">If a prescription is given to the patient</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub22!=2" :src="wrong"></el-image>
                                23) What type of codes are submitted for drugs, DME equipment and dental codes
                                that don't have an appropriate cross code?
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub22">
                                <el-radio-group ref="sub22" v-model="form.sub22" :disabled="isAdmin">
                                    <el-radio :label="0">HIPPS</el-radio><br>
                                    <el-radio :label="1">CPT</el-radio><br>
                                    <el-radio :label="2">HCPCS</el-radio>
                                    <el-image v-if="isAdmin&&form.sub22!=2" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="3">RVU</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub23!=0" :src="wrong"></el-image>
                                24) A patient can submit a claim directly to Medicare if the dentist is not enrolled with them.
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub23">
                                <el-radio-group ref="sub23" v-model="form.sub23" :disabled="isAdmin">
                                    <el-radio :label="0">True</el-radio>
                                    <el-image v-if="isAdmin&&form.sub23!=0" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="1">False</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&form.sub24!=1" :src="wrong"></el-image>
                                25) Should you submit to dental or medical insurance first?
                                <span class="required">*</span></div>
                            <div class="score" >2 points</div>
                            <el-form-item prop="sub24">
                                <el-radio-group ref="sub24" v-model="form.sub24" :disabled="isAdmin">
                                    <el-radio :label="0">Dental first, then Medical</el-radio><br>
                                    <el-radio :label="1">Medical first, then Dental</el-radio>
                                    <el-image v-if="isAdmin&&form.sub24!=1" class="rightPic" :src="right"></el-image><br>
                                    <el-radio :label="2">Send to Medical and Dental consecutively</el-radio><br>
                                    <el-radio :label="3">It doesn't matter, it's the Dr's choice.</el-radio>
                                </el-radio-group>
                            </el-form-item>
                        </div>

                        <div class="box">
                            <div class="subjectTest"><el-image v-if="isAdmin&&(!form.sub25.b||!form.sub25.d)" :src="wrong"></el-image>
                                26) What should be added to the claim when there is an anesthesia code? (select all
                                that apply)
                                <span class="required">*</span></div>
                            <div class="score" >3 points</div>
                            <el-form-item prop="sub25" ref="sub25">
                                <div>
                                    <el-checkbox v-model="form.sub25.a" :disabled="isAdmin">The patient's blood pressure & pulse</el-checkbox><br>
                                    <el-checkbox v-model="form.sub25.b" :disabled="isAdmin">Anesthesia start & stop times</el-checkbox>
                                    <el-image v-if="isAdmin&&(!form.sub25.b||!form.sub25.d)" class="rightPic" :src="right"></el-image><br>
                                    <el-checkbox v-model="form.sub25.c" :disabled="isAdmin">List of medications used</el-checkbox><br>
                                    <el-checkbox v-model="form.sub25.d" :disabled="isAdmin">Anesthesia modifiers</el-checkbox>
                                    <el-image v-if="isAdmin&&(!form.sub25.b||!form.sub25.d)" class="rightPic" :src="right"></el-image>
                                </div>
                            </el-form-item>
                        </div>
                        <div class="btnLayout">
                            <el-button class="yellowBtn" @click="submitPrepare" v-if="!isAdmin">Submit</el-button>
                            <el-button class="grayBtn" @click="cancel">Cancel</el-button>
                        </div>
                    </el-form>
                </div>

                <div class="box" v-if="showResult&&hasFinished">
                    <h1 class="serviceTestTitle">eAssist Medical Billing/Coding Assessment Test</h1>
                    <!--
                    <span>Of the parts of this exam that can be automatically graded you have recieved </span>
                    <span>{{correctNum}}</span>/{{totalNum}} ({{correctPercent}})-->
                    <span>Thank you for completing this knowledge assessment!</span><br/>
                    <span>Please allow up to three business days while we review your application.</span>
                    <br>
                    <el-button class="yellowBtn" style="margin-top: 10px;" @click="goPre">Back</el-button>
                </div>
            </section>
        </div>
        <el-dialog title="Confirm" :visible.sync="exitVisible">
            <div>Are you sure you want to cancel the test?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="goBack">Yes</el-button>
                <el-button class="grayBtn" @click="exitVisible=false">No</el-button>
            </span>
        </el-dialog>
        <el-dialog title="Confirm" :visible.sync="confirmVisible" width="50%">
            <div style="line-height: 25px;padding: 0 10px;word-wrap:break-word">Caution:this portion of our skills assessment test you are about to view cannot be saved for later. You will
                be scored with no option to return later if you proceed. Do you want to continue?</div>
            <span slot="footer">
                <el-button class="yellowBtn" @click="submit">Yes</el-button>
                <el-button class="grayBtn" @click="confirmVisible=false">No</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import ApplyHeader from "../../components/ApplyHeader"
    import Side from '../../components/Aside.vue'
    import wrong from "../../assets/pic/wrong.png"
    import right from "../../assets/pic/right.png"
    import { chat2Ascii } from "../../../static/js/util"
    export default {
        name: "Medical",
        components:{ApplyHeader,Side},
        data(){
            let validateEmpty = (rule, value, callback) => {
                console.log('here')
                if (!value.a&&!value.b&&!value.c&&!value.d) {
                    callback(new Error('Required'))
                } else {
                    callback()
                }
            }
            return{
                loading:false,
                rightAnswerSOAP:'Subjective, Objective, Assessment, Plan',
                wrong:wrong,
                right:right,
                exitVisible:false,
                confirmVisible:false,
                showResult:false,
                hasFinished:false,
                smallScreen:false,
                correctNum:0,
                totalNum:26,
                form:{
                    sub9:{},
                    sub25:{}
                },
                isAdmin:false,
                /**表单验证规则，所有选项都不允许为空  第10题和第26题如果一个都没有选也会提示**/
                rules: {
                    sub0: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub1: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub2: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub3: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub4: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub5: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub6: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub7: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub8: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub9: [
                        {required: true, message: 'Required', trigger: 'blur'},
                        { validator: validateEmpty, trigger: 'blur' }
                    ],
                    sub10: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub11: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub12: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub13: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub14: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub15: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub16: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub17: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub18: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub19: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub20: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub21: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub22: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub23: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub24: [
                        {required: true, message: 'Required', trigger: 'blur'},
                    ],
                    sub25: [
                        {required: true, message: 'Required', trigger: 'blur'},
                        { validator: validateEmpty, trigger: 'blur' }
                    ]
                }
            }
        },
        computed:{
            /**根据用户自己选择算出正确率**/
            correctPercent(){
                var per = (this.correctNum*100/this.totalNum).toFixed(2)+'%'
                return per
            },
            correctSoap(){
                return this.coverString(this.form.sub3,'subjective')&&this.coverString(this.form.sub3,'objective')
                    &&this.coverString(this.form.sub3,'assessment')&&this.coverString(this.form.sub3,'plan')
            },
            getHeight(){
                return document.documentElement.clientHeight
            }
        },
        methods:{
            getUserAnswerData(id,email){
                console.log('id',id);
                console.log('email',email);
                this.loading=true
                this.$axios.get(this.$URL.gradeUrl,{params:{serviceId:id,email:email}}).then(res=>{
                    this.loading=false
                    if(res&&res.code==0){
                        this.hasFinished=true
                        console.log('用户答题数据',res)
                        /**取到用户答题数据重构form显示答题详情**/
                        if(res.data!=null){
                            var list = res.data.detail
                            this.deconstructData(list)
                            this.calScore()
                        }
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            getData(){
                if(this.$route.query&&this.$route.query.model=='review'&&this.$route.query.verify){
                    var serviceId = this.$route.query.serviceId
                    var email = this.$route.query.email
                    var verify = this.$route.query.verify
                    var verifyCode = chat2Ascii(email)
                    if(verifyCode!=verify){
                         this.$router.push('/login')
                        return
                    }
                    this.getUserAnswerData(serviceId,email)
                    this.isAdmin=true
                    return
                }
                var storeService = this.$store.state.serviceInfo
                //when no serviceid info, go back to service list
                console.log('get serviceId:' + storeService.serviceId)
                if(storeService.serviceId == undefined){
                    this.$router.push({path:'/service'})
                    return
                }

                var user = localStorage.getItem('email')
                this.getUserAnswerData(storeService.serviceId,user)
                var status = storeService.status
                if(status==2||status==3){
                    this.showResult=true
                    this.passPercent = (((storeService.servicePassScore||0)/this.totalNum).toFixed(2)*100)+'%'
                }
            },
            deconstructData(data){
                if(!data)return
                // var jsonData = JSON.parse(data)
                var jsonData = data
                if(jsonData.length!=26){
                    console.log('答题数据错误')
                    return
                }
                for(var i=0;i<jsonData.length;i++){
                    var item = jsonData[i]
                    if(i==9||i==25){
                        if(item.indexOf('a')>=0)this.form['sub'+i].a=true
                        if(item.indexOf('b')>=0)this.form['sub'+i].b=true
                        if(item.indexOf('c')>=0)this.form['sub'+i].c=true
                        if(item.indexOf('d')>=0)this.form['sub'+i].d=true
                    }else{
                        this.form['sub'+i]=item
                    }
                    this.form = JSON.parse(JSON.stringify(this.form))
                }
            },
            rebuildData(){
                var list=[]
                for(var i=0;i<26;i++){
                    if(i==9||i==25){
                        var tempList=[],str
                        if(this.form['sub'+i].a)tempList.push('a')
                        if(this.form['sub'+i].b)tempList.push('b')
                        if(this.form['sub'+i].c)tempList.push('c')
                        if(this.form['sub'+i].d)tempList.push('d')
                        str = tempList.join('')
                        list.push(str)
                    }else list.push(this.form['sub'+i])
                }
                return list
            },
            coverString(subStr,str){
                subStr = subStr.toLowerCase()
                return subStr.indexOf(str)>=0
            },
            calScore(){//算正确分数 总分80
                var score=0
                this.correctNum=0
                if(!this.form.sub0) {score+=2;this.correctNum++}
                if(this.form.sub1==4) {score += 2;this.correctNum++}
                if(this.form.sub2==0) {score += 2;this.correctNum++}
                if(this.correctSoap){
                    score+=2;this.correctNum++
                }
                if(this.form.sub4==1) {score += 2;this.correctNum++}
                if(this.form.sub5==3) {score += 2;this.correctNum++}
                if(this.form.sub6==2) {score += 2;this.correctNum++}
                if(this.form.sub7==2) {score += 2;this.correctNum++}
                if(this.form.sub8==1) {score += 2;this.correctNum++}
                if(this.form.sub9.a&&this.form.sub9.b&&this.form.sub9.c&&this.form.sub9.d) {score+=2;this.correctNum++}
                if(this.form.sub10==3) {score += 5;this.correctNum++}
                if(this.form.sub11==1) {score += 5;this.correctNum++}
                if(this.form.sub12==0) {score += 5;this.correctNum++}
                if(this.form.sub13==1) {score += 5;this.correctNum++}
                if(this.form.sub14==3) {score += 8;this.correctNum++}
                if(this.form.sub15==2) {score += 5;this.correctNum++}
                if(this.form.sub16==1) {score += 5;this.correctNum++}
                if(this.form.sub17==1) {score += 5;this.correctNum++}
                if(this.form.sub18==1) {score += 2;this.correctNum++}
                if(this.form.sub19==0) {score += 2;this.correctNum++}
                if(this.form.sub20==3) {score += 2;this.correctNum++}
                if(this.form.sub21==1) {score += 2;this.correctNum++}
                if(this.form.sub22==2) {score += 2;this.correctNum++}
                if(this.form.sub23==0) {score += 2;this.correctNum++}
                if(this.form.sub24==1) {score += 2;this.correctNum++}
                if(this.form.sub25.b&&this.form.sub25.d&&!this.form.sub25.a&&!this.form.sub25.c) {score += 3;this.correctNum++}
                return score
            },
            goPre(){
                this.$router.go(-1)
            },
            goBack(){
                this.$router.push({path:'/service'})
            },
            cancel(){
                this.exitVisible=true
            },
            submit(){
                var score=0,list=[]
                // var list=[]
                // for(var i in this.form){
                //     list.push(this.form[i])
                // }
                list = this.rebuildData()
                score = this.calScore()
                console.log('submit',list)
                var storeService = this.$store.state.serviceInfo
                //var positionInfo = this.$store.state.positionInfo
                var params={}
                params.serviceId =storeService.serviceId
                params.versionId = storeService.serviceVersion
                params.score = score
                params.possible = 80
                params.positionId = 0
                params.status = score > storeService.servicePassScore ? 1: 0
                params.detail = JSON.stringify(list)
                params.applicantEmail=localStorage.getItem('email')
                this.loading=true
                this.$axios.post(this.$URL.serviceTestUrl,params).then(res=>{
                    this.loading=false
                    if(res.code==0){
                        this.goBack()
                    }else{
                        this.$message.error({message:res.msg})
                    }
                }).catch(err=>{
                    this.loading=false
                    this.$message.error({message:err})
                })
            },
            submitPrepare(){
                 // var params = this.rebuildData()
                 // console.log('传递参数',params)
                this.$refs['form'].clearValidate()
                this.$nextTick(() => {
                    this.$refs['form'].validate((valid,object) => {
                        if (valid) {
                            this.confirmVisible=true
                        }else {
                            var obj = Object.keys(object)[0]
                            let dom = this.$refs[obj]
                            dom.$el.scrollIntoView({
                                //滚动到指定节点
                                block: 'center', //值有start,center,end，nearest，当前显示在视图区域中间
                                behavior: 'smooth' //值有auto、instant,smooth，缓动动画（当前是慢速的）
                            })
                            console.log('error submit!!');
                            return false;
                        }
                    })
                })
            },
        },
        mounted() {
            var clientW = document.documentElement.clientWidth
            if(clientW<1220){
                this.smallScreen=true
            }
            this.getData()
        },
        watch:{
            '$route'(to,from){
                console.log(from.path)
                if(to.path==='/medicalBillingTest'){
                    this.getData()
                }
            }
        }
    }
</script>

<style scoped>
    .rightPic{
        width: 20px;
        position: absolute;
        right: 20px
    }
    .el-radio{
        width:200px;
        height:43px;
        line-height:20px!important;
    }
    .radioText{
        display: inline-block;
    }
    .box>>>.el-radio__label{
        vertical-align: middle!important;
    }
    .btnLayout{
        margin:10px 0 20px 15px
    }
    @media screen and (max-width: 1440px) {
        .btnLayout{
            margin:10px 0 20px 5px
        }
    }
    @media screen and (max-width: 1200px) {
        .btnLayout{
            margin:10px 0 20px 0px
        }
    }
</style>